import React from "react";
import {observer} from "mobx-react-lite";
import intl from "react-intl-universal";
import {useAppState, useRootStore, useUserState} from "@stores/AppStateContext";

import {getDaysLeft, getTotalDuration} from "../../../stores/client";
import {getDaysPassed} from "../../../utils/date";
import {UpgradePlanCard as UpgradePlanCardView} from "../../components/UpgradePlanCard/UpgradePlanCard";

import {MODALS} from "../../screens/modals/modal-names";

export const UpgradePlanCard = observer(() => {
    const appState = useAppState();
    const rootStore = useRootStore();
    const userState = useUserState();
    const clientRow = userState!.dsManager!.clientAR!.row!;
    const dayStart = clientRow.createdAt;
    const daysLeft = getDaysLeft(clientRow)
    const daysPast = getDaysPassed(dayStart)
    const totalDuration = getTotalDuration(clientRow);
    const percentage = (daysPast / totalDuration) * 100;
    const onClick = () => appState.setModal({name: MODALS.CHECKOUT, params: undefined});

    const isCollapsed = rootStore.isSidebarCollapsed;

    return (
        <UpgradePlanCardView
            isCollapsed={isCollapsed}
            title={intl.get('common.subscription.free_trial').d('Free trial')}
            daysLeftText={intl.getHTML('upgrade.plan.card.days_left', {daysLeft}).d(`<b>${daysLeft}</b> days left`)}
            upgradeText={intl.get('common.upgrade_now').d("Upgrade now")}
            progress={percentage}
            onUpgradeClick={onClick}
        />
    )
});
